export const reducer = (state, action) => {
	switch (action.type) {
		case 'setSelectedTaxonomies':
			return {
				...state,
				selectedTaxonomies: action.payload,
			};
		case 'setCurrentPage':
			return {
				...state,
				currentPage: action.payload,
			};
		case 'setSearchQuery':
			return {
				...state,
				searchQuery: action.payload,
			};
		case 'setLoading':
			return {
				...state,
				loading: action.payload,
			};
		case 'setSearchText':
			return {
				...state,
				searchText: action.payload,
			};
		case 'setSortBy':
			return {
				...state,
				sortBy: action.payload,
			};
		case 'setTaxonomies':
			return {
				...state,
				taxonomies: action.payload,
			};
		case 'setSearchResults':
			const result = action.payload;
			const suggestedResult =
				'undefined' !== typeof result.suggested_result
					? result.suggested_result
					: null;

			return {
				...state,
				posts: result.records,
				postsCount: result.found_posts,
				pagesCount: result.max_num_pages,
				suggestedResult,
			};
		case 'setFocusedDateInput':
			return {
				...state,
				focusedDateInput: action.payload,
			};
		case 'resetFilters':
			return {
				...state,
				selectedTaxonomies: {},
				selectedStartDate: null,
				searchQuery: '',
				searchText: '',
				selectedEndDate: null,
				focusedDateInput: null,
			};
		case 'setDateRange':
			const { startDate, endDate } = action.payload;

			const newState = {
				...state,
			};

			if ('object' === typeof startDate) {
				newState.selectedStartDate = startDate;
			}

			if ('object' === typeof endDate) {
				newState.selectedEndDate = endDate;
			}

			return newState;
	}
};
